import { render, staticRenderFns } from "./PlainGoldSpot.vue?vue&type=template&id=ed62cb98&scoped=true"
import script from "./PlainGoldSpot.vue?vue&type=script&lang=js"
export * from "./PlainGoldSpot.vue?vue&type=script&lang=js"
import style0 from "./PlainGoldSpot.vue?vue&type=style&index=0&id=ed62cb98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed62cb98",
  null
  
)

export default component.exports